export default "__VITE_ASSET__B06OxL6u__"